import { Col, Container, Row } from 'react-bootstrap';
import logo from '../assets/logo-gray.svg';

export const EarthGraphyFooter = () => (
  <footer className="mt-auto p-5 pb-2 bg-light">
    <Container as="footer">
      <Row>
        <Col md={4} lg={3}>
          <h4 className="text-center text-md-start">
            <a href="/" className="fw-bold link-secondary text-decoration-none">
              Earth-graphy
            </a>
          </h4>
        </Col>
        <Col md={8} lg={9} className="text-center text-md-start">
          <h6>
            <a href="http://www.satnavi.jaxa.jp/ja/" className="link-secondary text-decoration-none">
              第一宇宙技術部門
            </a>
          </h6>
          <ul className="list-unstyled text-muted">
            <li>衛星利用運用センター</li>
            <li>地球観測研究センター</li>
          </ul>
        </Col>
      </Row>
      <p className="text-center text-md-end">
        <a href="https://www.jaxa.jp/">
          <img src={logo} alt="JAXA logo" width="80" />
        </a>
      </p>
      <Row>
        <Col md={6}>
          <ul className="list-inline text-center text-md-start">
            <li className="list-inline-item">
              <small>
                <a href="https://www.jaxa.jp/policy_j.html" className="link-secondary">
                  サイトポリシー・利用規約
                </a>
              </small>
            </li>
            <li className="list-inline-item">
              <small>
                <a href="https://www.jaxa.jp/sitemap_j.html" className="link-secondary">
                  JAXA サイトマップ
                </a>
              </small>
            </li>
          </ul>
        </Col>
        <Col md={6}>
          <p className="text-center text-md-end text-muted">
            <small>&copy; 2022 Japan Aerospace Exploration Agency</small>
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
);
